import { IPaginatedParams, PageInfo } from '../../share-types'

export type ICreditBatch = {
  id: number
  userId: number
  sourceType: CreditBatchSourceType
  sourceId: number
  issuedCredits: number
  remainingCredits: number
  status: CreditBatchStatus
  expiresAt: string
  createdAt: string
  updatedAt: string
  userName?: string
}

export type ICreditBatchTransaction = {
  id: number
  type: CreditBatchTransactionType
  credits: number
  referenceType: CreditBatchReferenceType
  referenceId: number
  createdBy?: string
  createdAt: string
}

export type ICreditBatchDetails = {
  creditBatch: ICreditBatch
  transactions: ICreditBatchTransaction[]
}

export enum CreditBatchSourceType {
  PLAN_SUBSCRIPTION_CYCLE = 'PLAN_SUBSCRIPTION_CYCLE',
  TOP_UP_ORDER = 'TOP_UP_ORDER',
}

export enum CreditBatchStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  REVOKED = 'REVOKED',
}

export enum CreditBatchOrderBy {
  CREATED_AT = 'CREATED_AT',
  EXPIRES_AT = 'EXPIRES_AT',
}

export enum CreditBatchTransactionType {
  ISSUE = 'ISSUE',
  CONSUME = 'CONSUME',
  REFUND = 'REFUND',
  EXPIRE = 'EXPIRE',
  REVOKE = 'REVOKE',
  RESTORE = 'RESTORE',
}

export enum CreditBatchReferenceType {
  ORDER = 'ORDER',
  BOOKING = 'BOOKING',
  CREDIT_BATCH = 'CREDIT_BATCH',
  PLAN_SUBSCRIPTION_CYCLE = 'PLAN_SUBSCRIPTION_CYCLE',
}

export type ICreditBatchFilterParams = {
  id?: number
  userId?: number
  sourceType?: CreditBatchSourceType
  sourceId?: number
  status?: CreditBatchStatus
  expiresAtFrom?: string
  expiresAtTo?: string
  orderBy?: CreditBatchOrderBy
}

export type CreditBatchFilter = IPaginatedParams & ICreditBatchFilterParams

export type PaginatedCreditBatches = {
  pageInfo: PageInfo
  data: ICreditBatch[]
}
